import React, { useState, useMemo, useEffect } from "react";
import { useSelector } from "react-redux";
import { Row, Col, Input, Label, Spinner } from "reactstrap";
import { getJobs } from "../../../../api/jobs";
import ApplicationItem from "./ApplicationItem";
import NoApplicationFound from "./NoApplicationFound";

const PendingApplications = ({ jobApplications }) => {
  const { profile } = useSelector((state) => state.customer);

  const [selectedJobId, setSelectedJobId] = useState("");
  const [allPostedJobs, setAllPostedJobs] = useState([]);
  const [jobsLoading, setJobsLoading] = useState(false);

  // 🎯 fetch EVERY job this employer has posted (not just the ones that
  // have applications), so the dropdown always shows the full list.
  useEffect(() => {
    if (!profile?.id) return;

    setJobsLoading(true);
    getJobs(`&JobsSearch[employer_id]=${profile.id}`)
      .then((res) => {
        setAllPostedJobs(res?.data?.data || []);
      })
      .catch((err) => {
        console.error("Error fetching posted jobs:", err);
        setAllPostedJobs([]);
      })
      .finally(() => setJobsLoading(false));
  }, [profile?.id]);

  const pendingApplicationsList =
    jobApplications?.filter((item) => item?.status === "Pending") || [];

  const filteredApplications = useMemo(() => {
    if (!selectedJobId) return pendingApplicationsList;

    return pendingApplicationsList?.filter(
      (data) => String(data?.job?.id) === String(selectedJobId),
    );
  }, [pendingApplicationsList, selectedJobId]);

  const selectedJobTitle = useMemo(() => {
    if (!selectedJobId) return "";
    const job = allPostedJobs.find(
      (j) => String(j?.id) === String(selectedJobId),
    );
    return job?.job_title || job?.jobTitle || "";
  }, [allPostedJobs, selectedJobId]);

  return (
    <>
      <Row className="mb-4">
        <Col md={4}>
          <Label htmlFor="jobFilterPending" className="form-label">
            Filter by Job
          </Label>
          <Input
            type="select"
            id="jobFilterPending"
            className="form-select"
            value={selectedJobId}
            onChange={(e) => setSelectedJobId(e.target.value)}
            disabled={jobsLoading}
          >
            <option value="">All Jobs</option>
            {allPostedJobs.map((job) => (
              <option key={job.id} value={job.id}>
                {job.job_title || job.jobTitle}
              </option>
            ))}
          </Input>
          {jobsLoading && (
            <div className="mt-2">
              <Spinner size="sm" /> <span className="text-muted small">Loading jobs...</span>
            </div>
          )}
        </Col>
      </Row>

      {filteredApplications?.length > 0 ? (
        filteredApplications.map((data) => {
          return <ApplicationItem key={data?.id} data={data} />;
        })
      ) : (
        <NoApplicationFound
          message={
            selectedJobId
              ? `No pending applications found for "${selectedJobTitle}".`
              : "No Pending application found!"
          }
        />
      )}
    </>
  );
};

export default PendingApplications;